import { render, staticRenderFns } from "./BundleConfigDialog.vue?vue&type=template&id=836f0dec&scoped=true&"
import script from "./BundleConfigDialog.vue?vue&type=script&lang=js&"
export * from "./BundleConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./BundleConfigDialog.vue?vue&type=style&index=0&id=836f0dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836f0dec",
  null
  
)

export default component.exports